<template>
  <div class="card">
    <h5 class="card-header">Invoices</h5>
    <div class="card-body">
      <LoadingIndicator v-if="loading" centered />
      <div v-else-if="invoices.length">
        <table class="table">
          <thead>
            <tr>
              <th v-if="tokenCan('carriers:create-invoice')">QB ID</th>
              <th>Doc No.</th>
              <th class="text-right">Amount</th>
              <th class="text-right">Deposit</th>
              <th class="text-right">Balance</th>
              <th class="pl-5">Email Status</th>
              <th>Due Date</th>
              <th>Created At</th>
              <th>Updated At</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="invoice in invoices" :key="invoice.id">
              <td v-if="tokenCan('carriers:create-invoice')">
                <a :href="'https://qbo.intuit.com/app/invoice?txnId=' + invoice.qbId" target="_blank" rel="noopener noreferrer">{{ invoice.qbId }}</a>
              </td>
              <td>{{ invoice.docNumber }}</td>
              <td class="text-right">{{ invoice.amount | formatMoney }}</td>
              <td class="text-right">{{ invoice.deposit | formatMoney }}</td>
              <td class="text-right">{{ invoice.balance | formatMoney }}</td>
              <td class="pl-5">{{ invoice.emailStatus }}</td>
              <td><span v-if="invoice.dueDate">{{ invoice.dueDate | formatDate }}</span></td>
              <td>{{ invoice.createdAt | formatDateTime }}</td>
              <td><span v-if="invoice.updatedAt">{{ invoice.updatedAt | formatDateTime }}</span></td>
            </tr>
          </tbody>
        </table>
      </div>
      <div v-else class="alert alert-warning">No invoices available for this carrier.</div>
    </div>
  </div>
</template>

<script>
import { ApiClient } from '@/api/ApiClient';
import LoadingIndicator from '@/components/shared/LoadingIndicator';
import permissionsMixin from '/src/mixins/permissions';

export default {
  name: 'CarrierInvoices',
  props: {
    carrier: {
      type: Object,
      default: () => ({}),
    },
  },
  mixins: [permissionsMixin],
  components: {
    LoadingIndicator,
  },
  data() {
    return {
      invoices: [],
      loading: true,
    };
  },
  async mounted() {
    await this.fetchInvoices();
  },
  methods: {
    async fetchInvoices() {
      this.loading = true;
      const response = await ApiClient.carriers.invoices.get({ carrierId: this.carrier.id });
      if (response.status === 200) {
        this.invoices = response.data.data || [];
      }
      this.loading = false;
    },
  },
};
</script>
